import React, { useEffect, useState, } from 'react';
import './superxBatch.css'
import C2wSuperxProjectCard from '../../../common/C2wSuperxHome/projects/projectCard';
import { useParams } from 'react-router';

function C2wSuperxAllBatch() {

  const [superxData, setSuperxData] = useState(null)

  const { slug } = useParams()
  const generateSlug = (name) =>
    name?.toLowerCase().replace(/\s/g, "-").replace(/[^\w-]/g, "");

  useEffect(() => {
    fetch("/data/SuperxData/superx.json")
      .then((res) => res.json())
      .then((data) => {
        const superxData = data?.data?.find(
          (c) => generateSlug(c.slug) === slug
        );
        setSuperxData(superxData)
      })
      .catch((err) => {
        console.error("Failed to fetch course details:", err);
      });
  }, [slug]);



  const arr = [

    {
      svgLogo: (
        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7138 5.39184C16.3147 5.02818 17.0036 4.83594 17.706 4.83594C18.4083 4.83594 19.0972 5.02818 19.6981 5.39184L21.1127 6.25716C23.0976 7.47042 25.3581 7.74057 27.629 8.01281C28.3631 8.10101 29.0979 8.18851 29.825 8.30866C29.825 8.30866 29.841 9.58233 29.8243 10.1601L29.6791 15.1264C29.5541 19.3856 27.6603 23.424 24.4115 26.3589C22.8788 27.743 21.2933 28.9938 19.4717 30.0327C18.9348 30.3361 18.3329 30.5063 17.7166 30.5289C17.1003 30.5515 16.4875 30.4259 15.9298 30.1626C13.8262 29.1625 11.9636 27.8944 10.2629 26.3589C7.01408 23.424 5.12023 19.3856 4.99592 15.1264L4.85147 10.1761C4.8341 9.58997 4.85147 8.30866 4.85147 8.30866C5.44177 8.23921 6.0432 8.18157 6.64948 8.12392C9.32531 7.86974 12.09 7.60723 14.3582 6.22105L15.7138 5.39184ZM15.9423 15.9479V11.0866H18.7202V15.9479H23.5816V18.7259H18.7202V23.5872H15.9423V18.7259H11.081V15.9479H15.9423Z" fill="#9C6FF5" />
        </svg>
      ),
      bgColor: 'rgba(156, 111, 245, 0.3)',
    },
    {
      svgLogo: (
        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7138 5.39184C16.3147 5.02818 17.0036 4.83594 17.706 4.83594C18.4083 4.83594 19.0972 5.02818 19.6981 5.39184L21.1127 6.25716C23.0976 7.47042 25.3581 7.74057 27.629 8.01281C28.3631 8.10101 29.0979 8.18851 29.825 8.30866C29.825 8.30866 29.841 9.58233 29.8243 10.1601L29.6791 15.1264C29.5541 19.3856 27.6603 23.424 24.4115 26.3589C22.8788 27.743 21.2933 28.9938 19.4717 30.0327C18.9348 30.3361 18.3329 30.5063 17.7166 30.5289C17.1003 30.5515 16.4875 30.4259 15.9298 30.1626C13.8262 29.1625 11.9636 27.8944 10.2629 26.3589C7.01408 23.424 5.12023 19.3856 4.99592 15.1264L4.85147 10.1761C4.8341 9.58997 4.85147 8.30866 4.85147 8.30866C5.44177 8.23921 6.0432 8.18157 6.64948 8.12392C9.32531 7.86974 12.09 7.60723 14.3582 6.22105L15.7138 5.39184ZM15.9423 15.9479V11.0866H18.7202V15.9479H23.5816V18.7259H18.7202V23.5872H15.9423V18.7259H11.081V15.9479H15.9423Z" fill="#9C6FF5" />
        </svg>
      ),
      bgColor: 'rgba(156, 111, 245, 0.3)',
    },
    {
      svgLogo: (
        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7138 5.39184C16.3147 5.02818 17.0036 4.83594 17.706 4.83594C18.4083 4.83594 19.0972 5.02818 19.6981 5.39184L21.1127 6.25716C23.0976 7.47042 25.3581 7.74057 27.629 8.01281C28.3631 8.10101 29.0979 8.18851 29.825 8.30866C29.825 8.30866 29.841 9.58233 29.8243 10.1601L29.6791 15.1264C29.5541 19.3856 27.6603 23.424 24.4115 26.3589C22.8788 27.743 21.2933 28.9938 19.4717 30.0327C18.9348 30.3361 18.3329 30.5063 17.7166 30.5289C17.1003 30.5515 16.4875 30.4259 15.9298 30.1626C13.8262 29.1625 11.9636 27.8944 10.2629 26.3589C7.01408 23.424 5.12023 19.3856 4.99592 15.1264L4.85147 10.1761C4.8341 9.58997 4.85147 8.30866 4.85147 8.30866C5.44177 8.23921 6.0432 8.18157 6.64948 8.12392C9.32531 7.86974 12.09 7.60723 14.3582 6.22105L15.7138 5.39184ZM15.9423 15.9479V11.0866H18.7202V15.9479H23.5816V18.7259H18.7202V23.5872H15.9423V18.7259H11.081V15.9479H15.9423Z" fill="#9C6FF5" />
        </svg>
      ),
      bgColor: 'rgba(156, 111, 245, 0.3)',
    },
    {
      svgLogo: (
        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7138 5.39184C16.3147 5.02818 17.0036 4.83594 17.706 4.83594C18.4083 4.83594 19.0972 5.02818 19.6981 5.39184L21.1127 6.25716C23.0976 7.47042 25.3581 7.74057 27.629 8.01281C28.3631 8.10101 29.0979 8.18851 29.825 8.30866C29.825 8.30866 29.841 9.58233 29.8243 10.1601L29.6791 15.1264C29.5541 19.3856 27.6603 23.424 24.4115 26.3589C22.8788 27.743 21.2933 28.9938 19.4717 30.0327C18.9348 30.3361 18.3329 30.5063 17.7166 30.5289C17.1003 30.5515 16.4875 30.4259 15.9298 30.1626C13.8262 29.1625 11.9636 27.8944 10.2629 26.3589C7.01408 23.424 5.12023 19.3856 4.99592 15.1264L4.85147 10.1761C4.8341 9.58997 4.85147 8.30866 4.85147 8.30866C5.44177 8.23921 6.0432 8.18157 6.64948 8.12392C9.32531 7.86974 12.09 7.60723 14.3582 6.22105L15.7138 5.39184ZM15.9423 15.9479V11.0866H18.7202V15.9479H23.5816V18.7259H18.7202V23.5872H15.9423V18.7259H11.081V15.9479H15.9423Z" fill="#9C6FF5" />
        </svg>
      ),
      bgColor: 'rgba(156, 111, 245, 0.3)',
    },
    {
      svgLogo: (
        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7138 5.39184C16.3147 5.02818 17.0036 4.83594 17.706 4.83594C18.4083 4.83594 19.0972 5.02818 19.6981 5.39184L21.1127 6.25716C23.0976 7.47042 25.3581 7.74057 27.629 8.01281C28.3631 8.10101 29.0979 8.18851 29.825 8.30866C29.825 8.30866 29.841 9.58233 29.8243 10.1601L29.6791 15.1264C29.5541 19.3856 27.6603 23.424 24.4115 26.3589C22.8788 27.743 21.2933 28.9938 19.4717 30.0327C18.9348 30.3361 18.3329 30.5063 17.7166 30.5289C17.1003 30.5515 16.4875 30.4259 15.9298 30.1626C13.8262 29.1625 11.9636 27.8944 10.2629 26.3589C7.01408 23.424 5.12023 19.3856 4.99592 15.1264L4.85147 10.1761C4.8341 9.58997 4.85147 8.30866 4.85147 8.30866C5.44177 8.23921 6.0432 8.18157 6.64948 8.12392C9.32531 7.86974 12.09 7.60723 14.3582 6.22105L15.7138 5.39184ZM15.9423 15.9479V11.0866H18.7202V15.9479H23.5816V18.7259H18.7202V23.5872H15.9423V18.7259H11.081V15.9479H15.9423Z" fill="#9C6FF5" />
        </svg>
      ),
      bgColor: 'rgba(156, 111, 245, 0.3)',
    },
    {
      svgLogo: (
        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7138 5.39184C16.3147 5.02818 17.0036 4.83594 17.706 4.83594C18.4083 4.83594 19.0972 5.02818 19.6981 5.39184L21.1127 6.25716C23.0976 7.47042 25.3581 7.74057 27.629 8.01281C28.3631 8.10101 29.0979 8.18851 29.825 8.30866C29.825 8.30866 29.841 9.58233 29.8243 10.1601L29.6791 15.1264C29.5541 19.3856 27.6603 23.424 24.4115 26.3589C22.8788 27.743 21.2933 28.9938 19.4717 30.0327C18.9348 30.3361 18.3329 30.5063 17.7166 30.5289C17.1003 30.5515 16.4875 30.4259 15.9298 30.1626C13.8262 29.1625 11.9636 27.8944 10.2629 26.3589C7.01408 23.424 5.12023 19.3856 4.99592 15.1264L4.85147 10.1761C4.8341 9.58997 4.85147 8.30866 4.85147 8.30866C5.44177 8.23921 6.0432 8.18157 6.64948 8.12392C9.32531 7.86974 12.09 7.60723 14.3582 6.22105L15.7138 5.39184ZM15.9423 15.9479V11.0866H18.7202V15.9479H23.5816V18.7259H18.7202V23.5872H15.9423V18.7259H11.081V15.9479H15.9423Z" fill="#9C6FF5" />
        </svg>
      ),
      bgColor: 'rgba(156, 111, 245, 0.3)',
    },
  ]

  const renderedCards = superxData?.projects?.map((superxData, index) => {
    return <C2wSuperxProjectCard superxData={superxData} obj={arr[index]} />
  })

  return (
    <div className='C2wSuperxBatch_ctn'>
      <div className='C2wSuperxBatch_ctn_scroller'>
        <div className='C2wSuperxBatch_ctn_desc'
          style={{backgroundImage: `url(/assets/images/courseDetails/${superxData?.bgThumbnail})`}}
        >
          <div className="C2wSuperxBatch_ctn_desc_content">
            <h1>{superxData?.batchName}</h1>
            <div className='C2wSuperxBatch_ctn_thumbnail'>
              <img src={`/assets/superx/images/superxBatches/${superxData?.thumbnail}`} alt='' />
            </div>
          </div>
          <div className='C2wSuperBatchProjectGrid_ctn'>
            {renderedCards}
          </div>
        </div>
      </div>
    </div>
  )
}

export default C2wSuperxAllBatch;